import { FC, useEffect } from "react";
import Input from "shared/Input/Input";
import CommonLayout from "./CommonLayout";
import FormItem from "./FormItem";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentHolidayPackage, setHolidayPackage } from "application/features/holidayPackage/holidayPackageSlice";
import { useTranslation } from "react-i18next";

export interface AddHolidayPackage5bProps { }

const PageAddHolidayPackage5b: FC<AddHolidayPackage5bProps> = () => {

    const { t, ready } = useTranslation("translation");
    const holidayPackage = useSelector(selectCurrentHolidayPackage);
    const dispatch = useDispatch();

    const handleUpdateHolidayPackage = async (field: string, value: any) => {
        dispatch(setHolidayPackage({ ...holidayPackage, [field]: value }))
    };

    const _updateDefaultFields = async () => {
        dispatch(setHolidayPackage({ 
            ...holidayPackage, 
            min_guests: holidayPackage?.min_guests? holidayPackage.min_guests : undefined,
            max_guests: holidayPackage?.max_guests? holidayPackage.max_guests : undefined,
            latest_booking: holidayPackage?.latest_booking? holidayPackage.latest_booking : undefined,
        }))
    }

    function nextPageCondition() {
        return holidayPackage?.min_guests >= 1 && holidayPackage?.max_guests >= 1 && holidayPackage?.latest_booking >= 1;
    }

    useEffect(() => {
        _updateDefaultFields();
    }, []);

    if (!ready) return null;

    return (
        <CommonLayout
            index="05"
            backtHref={"/host/new-holiday-package/add-listing-4"}
            nextHref={"/host/new-holiday-package/add-listing-6"}
            canGoNext={nextPageCondition()}
        >
        <>
            <h2 className="text-2xl font-semibold">{t("translation:components.holidayPackageForm.page5b.title")}</h2>
            <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
            {/* FORM */}
            <div className="space-y-8">
                {/* MIN */}
                <FormItem
                    label={t("translation:components.holidayPackageForm.page5b.form.minNumberLabel")}
                >
                    <p className="text-sm font-medium text-neutral-500 dark:text-neutral-300 pb-2">{t("translation:components.holidayPackageForm.page5b.form.minNumberDescription")}</p>
                    <Input
                        type="number"
                        min={1}
                        defaultValue={holidayPackage?.min_guests}
                        onChange={(e) => handleUpdateHolidayPackage("min_guests", e.target.value)}
                        placeholder={t("translation:components.holidayPackageForm.page5b.form.minNumberPlaceholder")}
                    />
                </FormItem>
                {/* MAX */}
                <FormItem
                    label={t("translation:components.holidayPackageForm.page5b.form.maxNumberLabel")}
                >
                    <p className="text-sm font-medium text-neutral-500 dark:text-neutral-300 pb-2">{t("translation:components.holidayPackageForm.page5b.form.maxNumberDescription")}</p>
                    <Input
                        type="number"
                        min={1}
                        defaultValue={holidayPackage?.max_guests}
                        onChange={(e) => handleUpdateHolidayPackage("max_guests", e.target.value)}
                        placeholder={t("translation:components.holidayPackageForm.page5b.form.maxNumberPlaceholder")}
                    />
                </FormItem>
                {/* DAYS BEFORE LATEST BOOKING */}
                <FormItem
                    label={t("translation:components.holidayPackageForm.page5b.form.latestBookingLabel")}
                >
                    <p className="text-sm font-medium text-neutral-500 dark:text-neutral-300 pb-2">{t("translation:components.holidayPackageForm.page5b.form.latestBookingDescription")}</p>
                    <Input
                        type="number"
                        min={1}
                        defaultValue={holidayPackage?.latest_booking}
                        onChange={(e) => handleUpdateHolidayPackage("latest_booking", e.target.value)}
                        placeholder={t("translation:components.holidayPackageForm.page5b.form.latestBookingPlaceholder")}
                    />
                </FormItem>
            </div>
        </>
        </CommonLayout >
    );
};

export default PageAddHolidayPackage5b;